import { APP_ROUTES_FORMS } from '@data'
import { useDocTemplate } from '@hook'
import { DeleteModal } from '@ui'
import { getError, showToast } from '@util'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

type Props = {
  id?: string
  onClose: () => void
}

export const DeleteForm = ({ onClose, id }: Props) => {
  const { deleteDoc } = useDocTemplate()
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()

  const handleDelete = async () => {
    setIsLoading(true)
    try {
      await deleteDoc(id as string)
      onClose()
      showToast('Document deleted successfully')
      setIsLoading(false)
      navigate(APP_ROUTES_FORMS)
    } catch (error) {
      getError(error)
    } finally {
      setIsLoading(false)
    }
  }
  return (
    <DeleteModal
      description="Confirm that you want to delete this document"
      handleSubmit={handleDelete}
      isLoading={isLoading}
      onClose={onClose}
      title="Delete Document"
    />
  )
}
